module.exports = __webpack_public_path__ + "static/media/increase-icon.663f5aeb.svg";